import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "layoutType", "items", "autoSwipe", "pagination", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import cn from 'classnames';
import { useState } from 'react';
import { extractSupportProps } from '@sbercloud/uikit-product-utils';
import { Carousel } from '@snack-uikit/carousel';
import { PaginationSlider } from '@snack-uikit/pagination';
import { HeroSlide } from './components';
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function HeroSlider(_ref) {
  var id = _ref.id,
    layoutType = _ref.layoutType,
    items = _ref.items,
    autoSwipe = _ref.autoSwipe,
    _ref$pagination = _ref.pagination,
    pagination = _ref$pagination === void 0 ? true : _ref$pagination,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    currentPage = _useState2[0],
    setCurrentPage = _useState2[1];
  var currentSlideAppearance = items[currentPage].appearance;
  return /*#__PURE__*/_jsxs("section", {
    className: cn(styles.root, className),
    id: id,
    children: [/*#__PURE__*/_jsx(Carousel, _objectSpread(_objectSpread({
      className: styles.heroCarousel,
      arrows: false,
      pagination: false,
      infiniteScroll: true,
      autoSwipe: autoSwipe,
      state: {
        page: currentPage,
        onChange: setCurrentPage
      },
      gap: '0'
    }, extractSupportProps(rest)), {}, {
      children: items.map(function (item, i) {
        return /*#__PURE__*/_jsx(HeroSlide, _objectSpread(_objectSpread({}, item), {}, {
          layoutType: layoutType
        }), "".concat(item.title).concat(i));
      })
    })), pagination && /*#__PURE__*/_jsx("div", {
      className: styles.paginationWrapper,
      "data-appearance": currentSlideAppearance,
      children: /*#__PURE__*/_jsx(PaginationSlider, {
        "data-test-id": "hero-slider__pagination",
        page: currentPage + 1,
        onChange: function onChange(page) {
          setCurrentPage(page - 1);
        },
        total: items.length
      })
    })]
  });
}